import { t } from "i18next"
import { FormState } from "../component/ScheduleForm"

export const ScheduleValidator = {
    validateOnceSchedule: function(formState: Partial<FormState>, errors: Record<string, string>) {
        if (!formState.onceDate) errors.onceDate = t("Date is required")

        if (!!formState.onceDate) {
            const onceDate = new Date(formState.onceDate)
            const today = new Date()

            onceDate.setHours(0, 0, 0, 0)
            today.setHours(0, 0, 0, 0)

            if (onceDate < today)
                errors.onceDate = t("Date cannot be before today")
        }
    },

    validateDailySchedule: function(formState: Partial<FormState>, errors: Record<string, string>) {
        if (!formState.startDate) errors.StartDate = t("Start date is required")
        if (formState.repeatOnDayDaily?.length === 0) errors.repeatOnDayDaily = t("Repeat On (Days) is required")
    },

    validateWeeklySchedule: function(formState: Partial<FormState>, errors: Record<string, string>) {
        if (formState.repeatOnDayWeekly === undefined) errors.repeatOnDayWeekly = t("Repeat On (Day) is required")
    },

    validateFourWeeklySchedule: function(formState: Partial<FormState>, errors: Record<string, string>) {
        if (formState.repeatOnDayWeekly === undefined) errors.repeatOnDayWeekly = t("Repeat On (Day) is required")
    },

    validateMonthlySchedule: function(formState: Partial<FormState>, errors: Record<string, string>) {
        if (formState.repeatOnMonths?.length === 0) errors.repeatOnMonths = t("Repeat on (Month) is required")

        if (!formState.repeatOnWeekdayOnMonths) {
            if (formState.monthlyFrequencyDay?.length === 0) errors.monthlyFrequencyDay = t("Repeat On (Days) is required")
        } else {
            if (formState.monthlyOnWeekDays?.length === 0) errors.monthlyOnWeekDays = t("Repeat On is required")
            if (formState.monthlyFrequencyOnWeekDay?.length === 0) errors.monthlyFrequencyOnWeekDay = t("Repeat On (Day) is required")
        }
    }
}
